/**
 * @generated SignedSource<<1b28cd77704b74bbec340e36df965d23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InvoiceStatus = "applied" | "unapplied" | "unset";
export type UpdateInfluencerInfoMutationInput = {
  birthday?: string | null;
  clientMutationId?: string | null;
  commonName?: string | null;
  gender?: string | null;
  invoiceNo?: string | null;
  invoiceStatus?: InvoiceStatus | null;
  profile?: string | null;
  tiktokUrl?: string | null;
  twitterUrl?: string | null;
  ytChannel?: string | null;
};
export type SnsAssociationYoutubeMutation$variables = {
  input: UpdateInfluencerInfoMutationInput;
};
export type SnsAssociationYoutubeMutation$data = {
  readonly updateInfluencerInfo: {
    readonly __typename: "Influencer";
    readonly profile: {
      readonly ytChannel: string | null;
    };
  } | {
    readonly __typename: "UpdateInfluencerInfoError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type SnsAssociationYoutubeMutation = {
  response: SnsAssociationYoutubeMutation$data;
  variables: SnsAssociationYoutubeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ytChannel",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UpdateInfluencerInfoError",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SnsAssociationYoutubeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencerInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SnsAssociationYoutubeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateInfluencerInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a67c26c10b57d00414038c27521ccbf3",
    "id": null,
    "metadata": {},
    "name": "SnsAssociationYoutubeMutation",
    "operationKind": "mutation",
    "text": "mutation SnsAssociationYoutubeMutation(\n  $input: UpdateInfluencerInfoMutationInput!\n) {\n  updateInfluencerInfo(input: $input) {\n    __typename\n    ... on Influencer {\n      profile {\n        ytChannel\n        id\n      }\n      id\n    }\n    ... on UpdateInfluencerInfoError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed60cabbd57922eb4b44db9059f5e5fc";

export default node;
